<template>
  <div>

    <el-form label-position="left" label-width="150px">

      <el-divider content-position="left">申请人信息</el-divider>

      <el-form-item label="申请人" prop="">
        <el-input v-model="detail.userName" readonly></el-input>
      </el-form-item>

      <!--      <el-form-item label="所属部门" prop="">
              <el-input v-model="detail.deptName" readonly></el-input>
            </el-form-item>-->

      <el-divider content-position="left">报备信息</el-divider>

      <el-form-item label="报备项目" prop="projectId">
        <el-input v-model="detail.projectName" maxlength="12" readonly>
        </el-input>
      </el-form-item>

      <el-form-item label="报备类型" prop="costType">
        <el-radio-group v-model="detail.costType" disabled>
          <el-radio label="1">餐饮</el-radio>
          <el-radio label="2">烟</el-radio>
          <el-radio label="3">酒</el-radio>
          <el-radio label="4">礼品</el-radio>
          <el-radio label="5">其他</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="消费时间" prop="useTime">
        <el-date-picker
            readonly
            v-model="detail.useTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            type="datetime"
            placeholder="请选择消费时间">
        </el-date-picker>

      </el-form-item>

      <el-form-item label="预估金额" prop="costMoney">
        <el-input v-model="detail.costMoney" maxlength="12" readonly>
        </el-input>
      </el-form-item>

      <el-form-item label="申请事由" prop="reportSubject">
        <el-input type="textarea" rows="5" maxlength="500" show-word-limit readonly
                  v-model="detail.reportSubject"></el-input>
      </el-form-item>

      <el-form-item label="消费人" prop="">
        <el-input v-model="detail.userName" readonly></el-input>
      </el-form-item>

    </el-form>

  </div>


</template>

<script>
import Title from "../../Title";
import {requestApplyDetail, requestAudit, requestCostReportDetail} from "../../../api";

export default {
  components: {Title},
  name: "CostReportDialog",
  props: {"costReportId": "",},
  data() {
    return {
      detail: {},
      // costReportId: "",
      user: {},
    }
  },
  created() {
    //this.costReportId = this.$route.query.costReportId
    this.getObject()
  },
  methods: {
    getObject() {
      requestCostReportDetail({
        costReportId: this.costReportId,
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.detail = res.object.detail
            this.user = res.object.user
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    }
  }
}
</script>

<style>
.el-radio-group label, .el-checkbox-group label, input:disabled, .el-checkbox__label {
  opacity: 1;
  color: #606266;
  -webkit-text-fill-color: #606266;
}

</style>








